import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Globals } from './../../globals'
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-finish-import',
  templateUrl: './finish-import.component.html'
})
export class FinishImportComponent implements OnInit {
  public postId;
  public errorMessage;
  public titulo: string = "Finalizar importaciones a nivel nacional";
  import: Import[];
  user: User;
  pageActual: number = 1;

  finishForm = this.formBuilder.group({
    numeroPasaporte: new FormControl(''),
    numeroIdentificacionVin: new FormControl(''),
    correoElectronico: new FormControl(''),
    numeroAprobacion: new FormControl('')
  });

  constructor(private http: HttpClient, private router: Router, private formBuilder: FormBuilder, private globals: Globals, private cookies: CookieService) {
    var token = this.cookies.get("tokensessionFuncionario");
    if (token == "") {
      window.location.href = environment.redirecturl;
    }
    else {
      this.http.get<any>(`${environment.baseUrl}v1/sessionfuncionario/1?token=` + this.cookies.get("tokensessionFuncionario"))
        .subscribe({
          next: data => {
            this.user = data as User;

            this.globals.tipoDocumento = this.user.tipoDocumento;
            this.globals.numIdentificacion = this.user.numIdentificacion;
            this.globals.nombres = this.user.nombres;
            this.globals.apellidos = this.user.apellidos;
            this.globals.seccional = this.user.seccional;
            this.globals.idSeccional = this.user.idSeccional;
            this.globals.dependencia = this.user.dependencia;
            this.globals.idDependencia = this.user.idDependencia;
            this.globals.correo = this.user.correo;
            this.globals.activo = this.user.activo;
            this.globals.roles = this.user.rolesAutorizados.split(",");

            for (let i = 0; i < this.globals.roles.length; i++) {
              if (this.globals.roles[i] == "3244") {
                this.globals.r3244 = true;
              }
              if (this.globals.roles[i] == "3246") {
                this.globals.r3246 = true;
              }
              if (this.globals.roles[i] == "3247") {
                this.globals.r3247 = true;
              }
            }
          },
          error: error => {
            this.errorMessage = error.message;
          }
        })
    }
  }

  ngOnInit() {
    //this.http.get<any>(`${environment.baseUrl}v1/import/1?email=&numeroserial=&status=` + "2,5,6,7" + "&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
    //  .subscribe({
    //    next: data => {
    //      this.import = data as Import[];
    //      //this.router.navigate(["/import-request/solicitud"]);
    //    },
    //    error: error => {
    //      this.errorMessage = error.message;
    //      //console.error('There was an error!', error);
    //    }
    //  })
  }

  onSearchClick(email, numberchasis, id, idStatus) {
    if (idStatus == "7") {
      this.router.navigate(["/finish-manage-import/" + id]);
    }
    else {
      this.router.navigate(["/import-back/" + "consulta" + "/" + email + "/" + numberchasis + "/" + id + "/finish-import"]);
    }
  }

  onEditClick(id) {
    this.router.navigate(["/finish-manage-import/" + id ]);
  }


  search() {
    let element: HTMLElement = document.getElementById('abrircargando') as HTMLElement;
    element.click();
    this.pageActual = 1;
    var passportnumber = this.finishForm.controls["numeroPasaporte"].value;
    var chasisnumber = this.finishForm.controls["numeroIdentificacionVin"].value;
    var email = this.finishForm.controls["correoElectronico"].value;
    var idimport = this.finishForm.controls["numeroAprobacion"].value;
    var status = "2,5,6,7";

    this.http.get<any>(`${environment.baseUrl}v1/import/1?email=` + email + "&numeroserial=" + chasisnumber + "&status=" + status + "&passportnumber=" + passportnumber + "&importdate=&idimport=&approvednumber=" + idimport + "&sectionaladdresin=")
      .subscribe({
        next: data => {
          this.import = data as Import[];
          //this.router.navigate(["/import-request/solicitud"]);
          let element1: HTMLElement = document.getElementById('cerrarcargando') as HTMLElement;
          element1.click();
        },
        error: error => {
          this.errorMessage = error.message;
          //console.error('There was an error!', error);
        }
      })
  }

  clean() {
    this.pageActual = 1;
    this.finishForm.patchValue({
      numeroPasaporte: "",
      numeroIdentificacionVin: "",
      correoElectronico: "",
      numeroAprobacion: ""
    });

    this.import = []

    //this.http.get<any>(`${environment.baseUrl}v1/import/1?email=&numeroserial=&status=` + "2,5,6,7" + "&passportnumber=&importdate=&idimport=&approvednumber=&sectionaladdresin=")
    //  .subscribe({
    //    next: data => {
    //      this.import = data as Import[];
    //      //this.router.navigate(["/import-request/solicitud"]);
    //    },
    //    error: error => {
    //      this.errorMessage = error.message;
    //      //console.error('There was an error!', error);
    //    }
    //  })
  }
}

interface PortalBack {
  id: number;
  email: string;
}

class Import {
  id: string;
  sectionalAddressIn: string;
  sectionalAddressOut: string;
  touristName: string;
  touristCountry: string;
  passportNumber: string;
  nationality: string;
  dateOfArrival: string;
  touristCity: string;
  touristAddress: string;
  authorizedDuration: number;
  email: string;
  dateIn: string;
  dateOut: string;
  vehicleEntryForm: string;
  transportDocumentNumber: string;
  n1166DocumentNumber: string;
  ownershipDocumentNumber: string;
  registrationDate: string;
  typeClass: string;
  chassisNumber: string;
  licensePlate: string;
  make: string;
  model: number;
  engineNumber: string;
  countryOfRegistration: string;
  color: string;
  transportationName: string;
  nameFlag: string;
  entryPlace: string;
  registrationNumber: string;
  transportationChars: string;
  othersChars: string;
  idStatus: string;
  importDate: string;
  statusDate: string;
  approvedNumber: string;
  approvedDate: string;
}

class User {
  idToken: string;
  clientId: string;
  tipoDocumento: string;
  numIdentificacion: string;
  nombres: string;
  apellidos: string;
  seccional: string;
  idSeccional: string;
  dependencia: string;
  idDependencia: string;
  correo: string;
  activo: string;
  rolesAutorizados: string;
  infouser: string;
}
